import React from 'react';
import Modal2 from 'components/_shared/Modal2';
import MemberStatus from './components/MemberStatus';
import { CTAButton3 } from 'components/_shared/buttons';
import { makeStyles } from '@mui/styles';
import { MemberSearchResult } from 'types/index';

const useStyles = makeStyles(() => ({
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '32px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '40px'
    }
}));

const iconStyle = {
    backgroundColor: '#E7EFFE',
    border: '2px solid #062D7A',
    color: '#062D7A',
    fontSize: '24px'
};

type ExistingRestrictedMemberProps = {
    member: MemberSearchResult;
    closeButtonText: string;    
    handleCloseClick: () => void;
};

const ExistingRestrictedMember: React.FC<ExistingRestrictedMemberProps> = ({ member, closeButtonText, handleCloseClick }) => {
    const classes = useStyles();

    return (
        <Modal2
            onClose={handleCloseClick}
            additionalStyles={{ iconStyle: iconStyle }}
            iconName=""
            title="Existing Restricted Member"
        >
            <div className={classes.body}>
                <MemberStatus
                    photo={member.photo}
                    icon="far fa-check"
                    title={`${member.name} has an active membership!`}
                    subtext={`Because your organization is not part of ${member.name}'s membership's deployment, you can't view their profile. If you have questions, reach out to support.`}
                    colorType="green"
                />
                <div className={classes.buttonContainer}>
                    <CTAButton3 onClick={handleCloseClick}>
                        {closeButtonText}
                    </CTAButton3>
                </div>
            </div>
        </Modal2>
    );
};

export default ExistingRestrictedMember;
